import { Grid, Typography } from '@mui/material'
import React from 'react'
import useStyles from './Style'
import rehypeSlug from 'rehype-slug'
import ReactMarkdown from 'react-markdown'

interface IProps {
  content: {
    heading: string
    text: string
  }
}
const WhatHappens: React.FC<IProps> = ({ content }) => {
  const { heading, text } = content
  const { classes } = useStyles()
  return (
    <Grid className={classes.rootContainer}>
      <Typography className={classes.heading}>{heading}</Typography>
      <Typography className={classes.text}>
        <ReactMarkdown rehypePlugins={[rehypeSlug]}>{text}</ReactMarkdown>
      </Typography>
    </Grid>
  )
}

export default WhatHappens
